import React from 'react';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';
import Call from '../../components/Call';

const TallyUp = props => (
  <Layout bodyClass="page-contact">
    <SEO title="Contact" />
    <div className="intro intro-small">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h1>Tally Up</h1>
          </div>
        </div>
      </div>
    </div>
    <div className="container">
      <div className="row">
        <div className="col-12">
          <Call button={false} />
        </div>


        <div className="col-12 pt-5">
            <div className="col-12 pb-2">
               The monthly TallyUp™ is the cornerstone of OneAction. It’s the way you join OneAction and maintain your membership.
            </div>
            <div className="col-12 pb-2">
            To join OneAction, just send us an email with the subject join to tallyup@oneaction.nz - just a blank email
            </div>
            <div className="col-12 pb-2">
            The email subject is important, it helps us block spam, so you need to make sure you have the word "join" in the subject line
            </div>
            <div className="col-12 pb-2">
            At the end of every month, OneAction sends an email to all our members with the current TallyUp – that is, the total number of active members
            </div>
            
            <div className="col-12 pb-2">
            When you receive the monthly TallyUp email, if you still support OneAction's Vision and want to be counted in the next month’s TallyUp, simply reply to this email. It’s as simple as clicking Reply then Send
            </div>
            
            <div className="col-12 pb-2">
            This regular micro-donation of your willpower is how we build and Demonstrate the strength of OneAction. This way you’ll be able to see how we’re growing each month. If you don’t renew your membership it will expire and you’ll no longer receive updates or be counted in the TallyUp, but you can always re-join at any time
            </div>
              
            <div className="col-12 pb-2">
             OneAction is a Political Co-operative, so as a member you’re a part-owner, if you believe in the idea, help us find more kiwis who want to build a new way of doing politics in Aotearoa
             </div>
        </div>
     
      </div> 
    </div>
  </Layout>
);

export default TallyUp;
